import React, { useEffect, useState } from "react";
import PersianDatePicker from "../../Components/Core/DatePicker";
import Content from "../../Components/Core/Content";
import {
  getReservationsList,
  deleteReservation,
} from "../../Services/ReservationService";
import Loader from "../../Components/Core/Loader";
import { Button, Pagination, Chip, Tooltip } from "@mui/material";
import {
  faXmark,
  faSearch,
  faRotateRight,
  faCheck,
  faXmarkCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ConfirmModal from "../../Components/Modals/ConfirmModal";
import Notification from "../../Components/Core/Notification";

const AllReserves = () => {
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(
    new Date(new Date().setMonth(new Date().getMonth() + 5))
  );
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [nationalCode, setNationalCode] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [reserves, setReserves] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(15);
  const [totalItems, setTotalItems] = useState(0);
  const [hasActiveFilters, setHasActiveFilters] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedReserveId, setSelectedReserveId] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const handleDeleteReserve = async () => {
    setOpenDialog(false);
    try {
      setLoading(true);
      await deleteReservation(selectedReserveId);
      setOpenSnackbar(true);
      setSnackbarMessage("رزرو با موفقیت حذف شد");
      setSnackbarSeverity("success");
      await searchHandler();
    } catch (error) {
      setOpenSnackbar(true);
      setSnackbarMessage(error.message || "خطا در حذف رزرو");
      setSnackbarSeverity("error");
    } finally {
      setLoading(false);
    }
  };

  const searchHandler = async (page = 1) => {
    try {
      setLoading(true);
      const reservationPagingFilter = {
        fromDate,
        toDate,
        code: code.trim(),
        name: name.trim(),
        nationalCode: nationalCode.trim(),
        mobileNumber: mobileNumber.trim(),
        page,
        pageSize: itemsPerPage,
      };

      const response = await getReservationsList(reservationPagingFilter);

      setReserves(response.items || response);
      setTotalItems(response.totalCount || response.length);
      setCurrentPage(page);

      setHasActiveFilters(
        code.trim() || name.trim() || nationalCode.trim() || mobileNumber.trim()
      );
    } catch (error) {
      console.log(error.message);
      setSnackbarMessage("خطا در دریافت رزروها");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setCode("");
    setName("");
    setNationalCode("");
    setMobileNumber("");
    setHasActiveFilters(false);
    setFromDate(new Date());
    setToDate(new Date(new Date().setMonth(new Date().getMonth() + 5)));
    searchHandler(1);
  };

  const handlePageChange = (event, value) => {
    searchHandler(value);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  useEffect(() => {
    document.title = "مدیریت رزروها";
    searchHandler(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Content>
      <div className="container color-blue mb-5">
        {/* Header */}
        <h2 className="mb-4 row mt-5 highlight-box highlight-secondary fw-bold color-blue">
          <span>مدیریت رزروها</span>
        </h2>

        {/* Filters */}
        <div className="row mt-4">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-body p-3 p-md-4">
                {/* Desktop */}
                <div className="d-none d-md-block">
                  <div className="row g-3">
                    <div className="col-md-2">
                      <PersianDatePicker
                        name="از تاریخ"
                        value={fromDate}
                        onChange={setFromDate}
                      />
                    </div>

                    <div className="col-md-2">
                      <PersianDatePicker
                        name="تا تاریخ"
                        value={toDate}
                        onChange={setToDate}
                      />
                    </div>

                    <div className="col-md-2">
                      <label
                        className="form-label iran-sans mb-1"
                        style={{ fontSize: "14px" }}
                      >
                        کد پیگیری
                      </label>
                      <input
                        className="form-control form-blue iran-sans"
                        type="text"
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        placeholder="کد پیگیری"
                        style={{ height: "37px" }}
                      />
                    </div>

                    <div className="col-md-2">
                      <label
                        className="form-label iran-sans mb-1"
                        style={{ fontSize: "14px" }}
                      >
                        نام کاربر
                      </label>
                      <input
                        className="form-control form-blue iran-sans"
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="نام"
                        style={{ height: "37px" }}
                      />
                    </div>

                    <div className="col-md-2">
                      <label
                        className="form-label iran-sans mb-1"
                        style={{ fontSize: "14px" }}
                      >
                        موبایل
                      </label>
                      <input
                        className="form-control form-blue iran-sans"
                        type="tel"
                        value={mobileNumber}
                        onChange={(e) => setMobileNumber(e.target.value)}
                        placeholder="09123456789"
                        dir="ltr"
                        style={{ height: "37px" }}
                      />
                    </div>

                    <div className="col-md-2">
                      <label
                        className="form-label iran-sans mb-1"
                        style={{ fontSize: "14px" }}
                      >
                        کد ملی
                      </label>
                      <input
                        className="form-control form-blue iran-sans"
                        type="text"
                        value={nationalCode}
                        onChange={(e) => setNationalCode(e.target.value)}
                        placeholder="کد ملی"
                        dir="ltr"
                        style={{ height: "37px" }}
                      />
                    </div>
                  </div>

                  <div className="row mt-3">
                    <div className="col-12 d-flex gap-2">
                      <Button
                        variant="contained"
                        className="btn-blue"
                        onClick={() => searchHandler(1)}
                        style={{ height: "38px" }}
                      >
                        <FontAwesomeIcon icon={faSearch} className="me-2" />
                        <span>جستجو</span>
                      </Button>

                      {hasActiveFilters && (
                        <Button
                          variant="outlined"
                          onClick={handleReset}
                          style={{
                            height: "38px",
                            border: "1px solid #e9ecef",
                            color: "#053251",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faRotateRight}
                            className="me-2"
                          />
                          <span>پاک کردن</span>
                        </Button>
                      )}
                    </div>
                  </div>
                </div>

                {/* Mobile */}
                <div className="d-md-none">
                  <div className="row g-2">
                    <div className="col-6">
                      <label
                        className="form-label iran-sans mb-1"
                        style={{ fontSize: "12px" }}
                      >
                        از تاریخ
                      </label>
                      <PersianDatePicker
                        value={fromDate}
                        onChange={setFromDate}
                        placeholder="از تاریخ"
                      />
                    </div>

                    <div className="col-6">
                      <label
                        className="form-label iran-sans mb-1"
                        style={{ fontSize: "12px" }}
                      >
                        تا تاریخ
                      </label>
                      <PersianDatePicker
                        value={toDate}
                        onChange={setToDate}
                        placeholder="تا تاریخ"
                      />
                    </div>

                    <div className="col-6">
                      <input
                        className="form-control form-blue iran-sans"
                        type="text"
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        placeholder="کد پیگیری"
                        style={{ height: "38px", fontSize: "14px" }}
                      />
                    </div>

                    <div className="col-6">
                      <input
                        className="form-control form-blue iran-sans"
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="نام"
                        style={{ height: "38px", fontSize: "14px" }}
                      />
                    </div>

                    <div className="col-6">
                      <input
                        className="form-control form-blue iran-sans"
                        type="tel"
                        value={mobileNumber}
                        onChange={(e) => setMobileNumber(e.target.value)}
                        placeholder="موبایل"
                        dir="ltr"
                        style={{ height: "38px", fontSize: "14px" }}
                      />
                    </div>

                    <div className="col-6">
                      <input
                        className="form-control form-blue iran-sans"
                        type="text"
                        value={nationalCode}
                        onChange={(e) => setNationalCode(e.target.value)}
                        placeholder="کد ملی"
                        dir="ltr"
                        style={{ height: "38px", fontSize: "14px" }}
                      />
                    </div>

                    <div className="col-12 d-flex gap-2 mt-2">
                      <Button
                        variant="contained"
                        className="btn-blue flex-grow-1"
                        onClick={() => searchHandler(1)}
                        style={{ height: "38px" }}
                      >
                        <FontAwesomeIcon icon={faSearch} className="me-2" />
                        <span>جستجو</span>
                      </Button>

                      {hasActiveFilters && (
                        <Button
                          variant="outlined"
                          onClick={handleReset}
                          style={{
                            height: "38px",
                            minWidth: "38px",
                            padding: "0 12px",
                            border: "1px solid #e9ecef",
                            color: "#053251",
                          }}
                        >
                          <FontAwesomeIcon icon={faRotateRight} size="sm" />
                        </Button>
                      )}
                    </div>
                  </div>
                </div>

                {/* Active Filters */}
                {hasActiveFilters && (
                  <div className="mt-3 d-flex align-items-center gap-2 flex-wrap">
                    {code && (
                      <Chip
                        label={code}
                        onDelete={() => setCode("")}
                        size="small"
                        sx={{
                          backgroundColor: "#e8f5e9",
                          color: "#053251",
                          fontFamily: "iran-sans",
                          fontSize: "12px",
                          height: "24px",
                        }}
                      />
                    )}
                    {name && (
                      <Chip
                        label={name}
                        onDelete={() => setName("")}
                        size="small"
                        sx={{
                          backgroundColor: "#e8f5e9",
                          color: "#053251",
                          fontFamily: "iran-sans",
                          fontSize: "12px",
                          height: "24px",
                        }}
                      />
                    )}
                    {mobileNumber && (
                      <Chip
                        label={mobileNumber}
                        onDelete={() => setMobileNumber("")}
                        size="small"
                        sx={{
                          backgroundColor: "#e8f5e9",
                          color: "#053251",
                          fontFamily: "iran-sans",
                          fontSize: "12px",
                          height: "24px",
                        }}
                      />
                    )}
                    {nationalCode && (
                      <Chip
                        label={nationalCode}
                        onDelete={() => setNationalCode("")}
                        size="small"
                        sx={{
                          backgroundColor: "#e8f5e9",
                          color: "#053251",
                          fontFamily: "iran-sans",
                          fontSize: "12px",
                          height: "24px",
                        }}
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Results Info */}
        {!loading && reserves.length > 0 && (
          <div className="row mt-3">
            <div className="col-12">
              <div className="d-flex justify-content-between align-items-center">
                <span
                  className="iran-sans"
                  style={{ fontSize: "14px", color: "#6c757d" }}
                >
                  تعداد کل: {totalItems} رزرو
                </span>
                <span
                  className="iran-sans"
                  style={{ fontSize: "14px", color: "#6c757d" }}
                >
                  صفحه {currentPage} از {totalPages || 1}
                </span>
              </div>
            </div>
          </div>
        )}

        {/* Results */}
        {loading ? (
          <Loader />
        ) : reserves.length === 0 ? (
          <div className="row mt-4">
            <div className="col-12">
              <div
                className="card border-0 shadow-sm text-center py-5"
                style={{
                  background:
                    "linear-gradient(135deg, rgba(124, 200, 144, 0.05) 0%, rgba(5, 50, 81, 0.02) 100%)",
                }}
              >
                <div className="card-body">
                  <div style={{ fontSize: "48px", marginBottom: "16px" }}>
                    📅
                  </div>
                  <h5 className="iran-sans fw-bold color-blue">
                    رزروی یافت نشد
                  </h5>
                  <p className="iran-sans text-muted">
                    {hasActiveFilters
                      ? "با فیلترهای انتخابی، رزروی یافت نشد"
                      : "در بازه زمانی انتخابی، رزروی ثبت نشده است"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
            {/* Desktop Table */}
            <div className="row mt-4 d-none d-md-block">
              <div className="col-12">
                <div className="card border-0 shadow-sm">
                  <div className="table-responsive">
                    <table className="table table-hover mb-0 iran-sans">
                      <thead
                        style={{
                          background:
                            "linear-gradient(135deg, #053251 0%, #2a5a72 100%)",
                          color: "white",
                        }}
                      >
                        <tr>
                          <th className="p-3">کد پیگیری</th>
                          <th className="p-3">نام و نام خانوادگی</th>
                          <th className="p-3">موبایل</th>
                          <th className="p-3">کد ملی</th>
                          <th className="p-3">تاریخ</th>
                          <th className="p-3">ساعت</th>
                          <th className="p-3 text-center">پرداخت</th>
                          <th className="p-3 text-center">حذف</th>
                        </tr>
                      </thead>
                      <tbody>
                        {reserves.map((reserve) => (
                          <tr key={reserve.id}>
                            <td className="p-3">
                              <span className="badge bg-primary">
                                {reserve.code}
                              </span>
                            </td>
                            <td className="p-3 fw-bold">
                              {reserve.userFullName}
                            </td>
                            <td className="p-3" dir="ltr">
                              {reserve.mobileNumber}
                            </td>
                            <td className="p-3" dir="ltr">
                              {reserve.nationalCode || "—"}
                            </td>
                            <td className="p-3">{reserve.dateDisplay}</td>
                            <td className="p-3">{reserve.startTime}</td>
                            <td className="p-3 text-center">
                              {reserve.isPayed ? (
                                <FontAwesomeIcon
                                  icon={faCheck}
                                  style={{ color: "#7cc890", fontSize: "18px" }}
                                />
                              ) : (
                                <FontAwesomeIcon
                                  icon={faXmarkCircle}
                                  style={{ color: "#dc3545", fontSize: "18px" }}
                                />
                              )}
                            </td>
                            <td className="p-3 text-center">
                              <Tooltip title="حذف رزرو" arrow>
                                <FontAwesomeIcon
                                  className="text-danger"
                                  icon={faXmark}
                                  size="lg"
                                  onClick={() => {
                                    setSelectedReserveId(reserve.id);
                                    setOpenDialog(true);
                                  }}
                                  style={{ cursor: "pointer" }}
                                />
                              </Tooltip>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            {/* Mobile Cards */}
            <div className="row mt-4 d-md-none">
              {reserves.map((reserve) => (
                <div key={reserve.id} className="col-12 mb-3">
                  <div
                    className="card border-0 shadow-sm"
                    style={{
                      borderRadius: "16px",
                      overflow: "hidden",
                      border: reserve.isPayed
                        ? "2px solid #7cc890"
                        : "2px solid #e9ecef",
                    }}
                  >
                    <div
                      style={{
                        background: reserve.isPayed
                          ? "linear-gradient(135deg, #7cc890 0%, #6bb57f 100%)"
                          : "linear-gradient(135deg, #6c757d 0%, #5a6268 100%)",
                        padding: "12px 16px",
                        color: "white",
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <span className="iran-sans fw-bold">
                            {reserve.userFullName}
                          </span>
                          <div
                            className="iran-sans"
                            style={{ fontSize: "12px", marginTop: "4px" }}
                          >
                            کد: {reserve.code}
                          </div>
                        </div>
                        <Tooltip title="حذف رزرو" arrow>
                          <FontAwesomeIcon
                            icon={faXmark}
                            size="lg"
                            style={{ cursor: "pointer", color: "#ff6b6b" }}
                            onClick={() => {
                              setSelectedReserveId(reserve.id);
                              setOpenDialog(true);
                            }}
                          />
                        </Tooltip>
                      </div>
                    </div>

                    <div className="card-body p-3">
                      <div className="iran-sans" style={{ fontSize: "14px" }}>
                        <div className="mb-2 d-flex justify-content-between">
                          <strong>تاریخ و ساعت:</strong>
                          <span>
                            {reserve.dateDisplay} - {reserve.startTime}
                          </span>
                        </div>
                        <div className="mb-2 d-flex justify-content-between">
                          <strong>موبایل:</strong>
                          <span dir="ltr">{reserve.mobileNumber}</span>
                        </div>
                        {reserve.nationalCode && (
                          <div className="mb-2 d-flex justify-content-between">
                            <strong>کد ملی:</strong>
                            <span dir="ltr">{reserve.nationalCode}</span>
                          </div>
                        )}
                        <div className="d-flex justify-content-between">
                          <strong>وضعیت پرداخت:</strong>
                          <span>
                            {reserve.isPayed ? (
                              <span style={{ color: "#7cc890" }}>
                                <FontAwesomeIcon
                                  icon={faCheck}
                                  className="me-1"
                                />
                                پرداخت شده
                              </span>
                            ) : (
                              <span style={{ color: "#dc3545" }}>
                                <FontAwesomeIcon
                                  icon={faXmarkCircle}
                                  className="me-1"
                                />
                                پرداخت نشده
                              </span>
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="row mt-4 pb-5">
                <div className="col-12 d-flex justify-content-center">
                  <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={handlePageChange}
                    color="primary"
                    size="large"
                    showFirstButton
                    showLastButton
                    sx={{
                      "& .MuiPaginationItem-root": {
                        fontFamily: "MyPersianFont, sans-serif",
                        "&.Mui-selected": {
                          backgroundColor: "#7cc890",
                          color: "white",
                          "&:hover": {
                            backgroundColor: "#6bb57f",
                          },
                        },
                      },
                    }}
                  />
                </div>
              </div>
            )}
          </>
        )}
      </div>

      <ConfirmModal
        handleCloseDialog={() => setOpenDialog(false)}
        handleConfirm={handleDeleteReserve}
        openDialog={openDialog}
        text={["آیا از حذف این رزرو مطمئن هستید؟"]}
        cancleText="خیر"
        confirmText="بله"
        title="حذف رزرو"
      />

      <Notification
        openSnackbar={openSnackbar}
        snackbarMessage={snackbarMessage}
        snackbarSeverity={snackbarSeverity}
        setOpenSnackbar={setOpenSnackbar}
      />
    </Content>
  );
};

export default AllReserves;
